import { render, staticRenderFns } from "./SelectForeign.vue?vue&type=template&id=8dd8525c"
import script from "./SelectForeign.vue?vue&type=script&lang=js"
export * from "./SelectForeign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports